import { Header } from './Header'
import { Footer } from './Footer'
import { Routes, Route, useLocation } from 'react-router-dom'
import { Home } from '../../pages/Home'
import { ContactUs } from '../../pages/Forms/Contact'
import { NotFound } from '../../pages/Error/404'
import { PrivacyPolicy } from '../../pages/General/PrivacyPolicy'
import SurveyBeginning from '../../pages/Survey/Beginning'
import SurveyStart from '../../pages/Survey/Start'
import { PilotPage } from '../../pages/Pilot'

// Routes that render without the site header and footer
const HEADERLESS_ROUTES = ['/pilot']

export const Layout = () => {
    const location = useLocation()
    const isHeaderless = HEADERLESS_ROUTES.some((r) => location.pathname === r)

    return (
        <>
            {!isHeaderless && <Header />}
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/contact-us" element={<ContactUs />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/survey/beginning" element={<SurveyBeginning />} />
                <Route path="/survey/start" element={<SurveyStart />} />
                {/* Pilot / positioning test pages — linked from ad campaigns only */}
                <Route path="/pilot" element={<PilotPage />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
            {!isHeaderless && <Footer />}
        </>
    )
}